export default __webpack_public_path__ + "static/media/live-white.1ac8f694.svg";